/* eslint-disable no-undef, no-unused-vars */
$(function () {
    $("body").on("checkout:submitAffirm", function (e, data) {
        if ($(".payment-information").attr("data-payment-method-id") !== "Affirm") {
            return true;
        }
        if (!$("#vcn-data").data("affirmselected") || window.vcn_approved) {
            return true;
        }
        var checkoutObject = $("#vcn-data").data("vcndata");
        if ($("#affirm-inline-container").length > 0) {
            affirm.checkout.init();
        }
        if ($("#vcn-data").data("enabled")) {
            var $thisBtn = $(".place-order");
            e.preventDefault();
            affirm.checkout.open_vcn({
                success: function (card_details) {
                    $.ajax({
                        url: $("#vcn-data").data("updateurl") + "?" + $("#vcn-data").data("csrfname") + "=" + $("#vcn-data").data("csrftoken"),
                        data: card_details,
                        dataType: "json",
                        method: "POST",
                        success: function (response) {
                            if (!response.error) {
                                window.dispatchEvent(new CustomEvent("checkoutAffirmPaymentResponse", { detail: { status: "approved" } }));
                                $("#vcn-data").data("vcncomplete", true);
                                window.vcn_approved = true;
                                $thisBtn.click();
                            } else if ($(".error-message").length > 0) {
                                $(".error-message").show();
                                $(".error-message-text").text($("#vcn-data").data("errormessages").default);
                            } else if ($("div.error-form").length) {
                                $("div.error-form").text($("#vcn-data").data("errormessages").default);
                            } else {
                                $("table.item-list").before("<div class=\"error-form\">" + $("#vcn-data").data("errormessages").default + "</div>");
                            }

                            if (response.error) {
                                window.dispatchEvent(new CustomEvent("checkoutAffirmPaymentResponse", {
                                    detail: {
                                        message: $("#vcn-data").data("errormessages").default,
                                        type: "affirm error",
                                        status: "denied"
                                    }
                                }));
                            }
                        },
                        error: function (error) {
                            $("table.item-list").before("<div class='error-form'>Error in establishing connection with Affirm VCN service!</div>");

                            if (response.error) {
                                window.dispatchEvent(new CustomEvent("checkoutAffirmPaymentResponse", {
                                    detail: {
                                        message: "Error in establishing connection with Affirm VCN service!",
                                        type: "affirm error",
                                        status: "error"
                                    }
                                }));
                            }
                        },
                        done: function () {}
                    });
                },
                error: function (error) {
                    if (error.reason == "canceled" || error.reason == "closed") {
                        window.location.assign($("#vcn-data").data("errorurl"));
                        return;
                    }
                    var errorText = "";
                    var errorCollection = $("#vcn-data").data("errormessages");
                    errorText = errorCollection[error.reason] || errorCollection.default;
                    if ($("div.error-form").length) {
                        $("div.error-form").text(errorText);
                    } else {
                        $("table.item-list").before("<div class=\"error-form\">" + errorText + "</div>");
                    }
                },
                checkout_data: checkoutObject
            });
        } else if (checkoutObject.metadata.mode == "modal") {
            e.preventDefault();
            affirm.checkout(checkoutObject);
            affirm.checkout.open({
                onFail: function (a) {
                    window.location.assign(checkoutObject.merchant.user_cancel_url);
                },
                onSuccess: function (data) {
                    var csrftoken = $("#vcn-data").data("csrfname") + "=" + $("#vcn-data").data("csrftoken");
                    var url = checkoutObject.merchant.user_confirmation_url + "?checkout_token=" + data.checkout_token + "&" + csrftoken;
                    window.location.assign(url);
                }
            });
        } else {
            e.preventDefault();
            affirm.checkout(checkoutObject);
            affirm.checkout.post();
        }
    });
    $(document).on("product:afterAttributeSelect", function (data, container) {
        var newPrice = null;
        var product = container.data.product;

        // Check if priceV2 is available and use its min value
        if (product.priceV2 && product.priceV2.sale && product.priceV2.sale.min && product.priceV2.sale.min.value) {
            newPrice = product.priceV2.sale.min.value;
        } else if (product.priceV2 && product.priceV2.list && product.priceV2.list.min && product.priceV2.list.min.value) {
            newPrice = product.priceV2.list.min.value;
        } else if (product.price.sales) {
            newPrice = product.price.sales.value;
        } else if (product.price.list) {
            newPrice = product.price.list.value;
        } else if (product.price.startingFromPrice) {
            newPrice = product.price.startingFromPrice.sales.value;
        }

        // Update the specific element
        var $affirmAsLowAs = $(container.container).find(".affirm-as-low-as");
        var quantity = parseInt($(container.container).find(".js-qty-input").val(), 10);

        if (quantity > 1) {
            newPrice = newPrice * quantity;
        }

        $affirmAsLowAs.attr("data-amount", (newPrice * 100).toFixed());

        if (typeof affirm.ui.refresh !== "undefined") {
            affirm.ui.refresh();
        }

        if ($(".js-affirm-min-total").val() <= newPrice) {
            $affirmAsLowAs.removeClass("d-none");
        } else {
            $affirmAsLowAs.addClass("d-none");
        }
    });
    $(document).on("checkout:updateCheckoutView", function (e, data) {
        $(".affirm-product-modal").attr("data-amount", (data.order.totals.grandTotal.substr(1) * 100).toFixed());
        if (typeof affirm.ui.refresh !== "undefined") {
            affirm.ui.refresh();
        }
    });
    $(document).on("cart:update", function (e, data) {
        var $affirmAsLowAs = $(".affirm-as-low-as");
        var grandTotal = null;
        var minValue = parseFloat($(".js-affirm-min-total").val());

        // Check which grandTotal is available and use it
        if (data.totals && data.totals.estimatedGrandTotalValue) {
            grandTotal = data.totals.estimatedGrandTotalValue;
        } else if (data.cartModel && data.cartModel.totals && data.cartModel.totals.estimatedGrandTotalValue) {
            grandTotal = data.cartModel.totals.estimatedGrandTotalValue;
        } else if (data.basket && data.basket.totals && data.basket.totals.estimatedGrandTotalValue) {
            grandTotal = data.basket.totals.estimatedGrandTotalValue;
        }

        if (grandTotal !== null && !isNaN(grandTotal)) {
            $affirmAsLowAs.attr("data-amount", (grandTotal * 100).toFixed());

            if (typeof affirm.ui.refresh !== "undefined") {
                affirm.ui.refresh();
            }

            if (minValue <= grandTotal) {
                $affirmAsLowAs.removeClass("d-none");
            } else {
                $affirmAsLowAs.addClass("d-none");
            }
        }
    });
    affirm.ui.ready(
        function () {
            affirm.ui.error.on("close", function () {
                window.location.replace($("#vcn-data").data("errorurl"));
            });
        }
    );
});
